export default {
    BASE_URL: 'base_url',
    USER_TOKEN: 'user_token',
    ISBUSY: 'ISBUSY',
    NOTIFICATION: 'NOTIFICATION',
    CONFIRM: 'CONFIRM',
    QRCODE: 'QRCODE',
    QRCODE_RESULT: 'QRCODE_RESULT'
}

export const notificationType = {
    warning: 'warning',
    error: 'error',
    info: 'info',
    success: 'success'
}

export const invoiceKeyStore = {
    INVOICE: "INVOICE",
    INVOICE_SET_PRODUCT: 'INVOICE_SET_PRODUCT',
    INVOICE_PRODUCT_OPTION_SELECTED: 'INVOICE_PRODUCT_OPTION_SELECTED',
    COPY_INVOICE_TOGGLE: "COPY_INVOICE_TOGGLE",
    FEATURED_PRODUCT: "FEATURED_PRODUCT"
}

export const invoicePackageKeyStore = {
    CURRENT_STEP: 'INVOICE_PACKAGE_PAYMENT_CURRENT_STEP',
    CART: 'INVOICE_PACKAGE_PAYMENT_CART',
    CART_PACKAGE_SELECTED: 'CART_PACKAGE_SELECTED',
}

export const sessionKey = {
    AUTH_REQUEST: 'AUTH_REQUEST',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
    USER_TOKEN: 'USER_TOKEN',
    AUTH_SUCCESS: 'AUTH_SUCCESS',
    USER_PROFILE: 'USER_PROFILE'
}

export const languageKey = {
    LOCALE: 'LOCALE'
}